module.exports = __webpack_public_path__ + "static/solo-signup-0f7ac20703d578831bf8d9228a385a49.png";